import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Toolbar from 'components/Layout/Toolbar';
import { IManual } from 'interfaces/manual';
import React, { Fragment } from 'react';
import RxOp from 'rxjs-operators';
import manualService from 'services/manual';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import Container from '@material-ui/core/Container';
import CardHeader from '@material-ui/core/CardHeader';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableBody from '@material-ui/core/TableBody';
import ListItem from './ListItem';
import { WithStyles } from 'decorators/withStyles';
import { IStateList, ListComponent, TableCellSortable } from 'components/Abstract/List';
import { IPaginationParams } from 'interfaces/pagination';

interface IProps {
  classes?: any;
}

@WithStyles({
  title: {
    fontWeight: 700,
  }
})

class Manual extends ListComponent<IProps, IStateList<IManual>> {
  constructor(props: {}) {
    super(props, 'createdDate', 'desc');
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = (params: Partial<IPaginationParams> = {}) => {
    this.setState({ loading: true, error: null });

    manualService.list(this.mergeParams(params)).pipe(
      RxOp.logError(),
      RxOp.bindComponent(this)
    ).subscribe(items => {
      this.setPaginatedData(items);
    }, error => this.setError(error));
  }

  onClickRefresh = () => this.loadData();

  render() {
    const { loading, items } = this.state;
    const { classes } = this.props;

    return (
      <Fragment>
        <Toolbar title='Configurações' breadcrumbs={[{ title: 'Configurações' }, { title: 'Documentos do sistema' }]} />
        <Container>
          <Card>
            <CardHeader
              classes={{ title: classes.title }}
              title='Documentos do Sistema'
              subheader='Clique no documento abaixo para exibir o arquivo'
            />
            <CardContent>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCellSortable {...this.sortableProps} column='filename'>
                          Arquivo
                      </TableCellSortable>
                      <TableCellSortable {...this.sortableProps} column='createdDate'>
                          Data do upload
                      </TableCellSortable>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.renderEmptyAndErrorMessages(2)}
                    {(!loading && items) && items.map(manual => (
                      <ListItem key={`manual-item-${manual.id}`} manual={manual} />
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              {this.renderTablePagination()}
            </CardContent>
          </Card>
        </Container>
      </Fragment>
    );
  }
}

export default Manual;